// Top-level POST lets the API bind Meta's callback to this browser on Safari.
// Keep one-use launch credentials out of URLs, history and referrers.
export function launchSocialAuthorization(result, backendUrl, doc = document) {
  const target = new URL(result.url);
  const backend = new URL(backendUrl);
  if (target.protocol !== 'https:' || target.origin !== backend.origin
      || target.pathname !== '/api/marketing/social/authorize'
      || target.search || target.hash || target.username || target.password
      || !/^[A-Za-z0-9_-]{20,200}$/.test(result.state || '')
      || !/^[A-Za-z0-9_-]{20,200}$/.test(result.launch_token || '')) {
    throw new Error('Collegamento social non disponibile. Riprova dalle impostazioni.');
  }
  const form = doc.createElement('form');
  form.method = 'POST';
  form.action = target.href;
  form.target = '_self';
  form.hidden = true;
  for (const name of ['state', 'launch_token']) {
    const input = doc.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = result[name];
    form.appendChild(input);
  }
  doc.body.appendChild(form);
  try { form.submit(); } finally { form.remove(); }
}
